<template>
  <v-dialog
    v-model="toggle"
    scrollable
    transition="slide-y-reverse-transition"
    style="max-height: 90vh !important;"
    light
    fullscreen
  >
    <v-card class="terms white">
      <v-btn
        absolute
        top
        right
        fab
        icon
        class="mt-8 mr-n4"
        @click="close"
      >
        <v-icon>{{ icons.mdiClose }}</v-icon>
      </v-btn>
      <v-card-text 
        class="py-4 grey--text text--darken-3"
      >
        <icon-base
          width="37"
          height="43"
          name="hive"
          class="hive mt-4 mb-8 black--text"
          style="height: 32px;"
        >
          <brand-symbol />
        </icon-base>
        
        <component :is="content" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          color="grey"
          text
          @click="close"
        >
          Voltar
        </v-btn>
        <!-- <v-spacer />
        <v-btn
          color="primary darken-1"
          text
          @click="acceptTOS(true)"
        >
          Aceitar

        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

  .v-dialog:not(.v-dialog--fullscreen) {
    max-height: 90% !important;
  }

  .terms {
    border-radius: 0 !important;
  }

  .terms ol { 
    padding: 1rem 0 0;
    list-style-position: outside;
    counter-reset: item;
  }
  .terms ol li { 
    display: inline-block;
    padding-bottom: 1rem;
  }
  .terms ol>li:before {
    font-weight: 700;
    content: counters(item, ".") ". ";
    counter-increment: item;
  }
  .terms ol ul {
    padding: 1rem 0 0 1rem;
    list-style-position: outside;
    list-style-type: square !important;
  }
  .terms ol ul>li:before {
    content: '■ ';
  }

</style>

<script>
  // Utilities
  import {
    mdiClose
  } from '@mdi/js'
  import { get, sync } from 'vuex-pathify'
  import services from '@/services.js'

  export default {
    name: 'Tos',

    data: () => ({
      icons: {
        mdiClose
      },
      contents: {
        // '1:5': 'org-1-fleet-5',
        '3': 'org-3',
        '4': 'org-4',
        'es-ar': 'org-4'
      },
      btnAccept: {
        disabled: false,
        loading: false
      }
    }),

    computed: {
      accepted: sync('app/views@tos.accepted'),
      toggle: sync('app/views@tos.toggle'),
      user: sync('user'),
      // toast: sync('app/toast'),

      content () {
        const contents = this.contents;
        const profile = this.user.profile;
        return this.getContent(profile, contents);
      }
    },

    methods: {
      ...services,

      close () {
        this.toggle = false;
        if (this.$route.name=='Termos de Uso') this.$router.push('/');
      },

      acceptTOS (b) {
        this.accepted = b;
        this.close();
      }
    },

    components: {
      Default: () => import('@/views/help/terms/Default'),
      Org3: () => import('@/views/help/terms/MiOOH'),
      Org4: () => import('@/views/help/terms/MobeesAR'),
      // Org1Fleet5: () => import('@/views/help/terms/TermsOrg1Fleet5'), 
    },

  }
</script>
